import { useContext } from 'react';
import { NotifierContext } from './NotifierProvider';
/**
 * Wrapper hook for notifer context
 * @returns
 */
function useNotifier() {
  const {
    message,
    severity,
    showMessage,
    showErrorMessage,
    showInfoMessage,
    removeMessage,
    subMessages,
  } = useContext(NotifierContext);
  return { message, severity, subMessages,
    showMessage, showErrorMessage, showInfoMessage, removeMessage };
}

export default useNotifier;
